// extracted by mini-css-extract-plugin
module.exports = {"competitionSidebar":"CompetitionSidebar_competitionSidebar__40XoY"};